// extracted by mini-css-extract-plugin
module.exports = {"mod-cut":"Cut_mod-cut__mzW0Y"};